<template>
  <div v-if="props.slug" class="header-news-component">
    <img :src="logos.logoMini" :alt="howToTitle" class="w-4 h-4" />
    <NuxtLink :to="getLocalizedRoute(Routes.BlogSlug, { slug: props.slug })">
      {{ howToTitle }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import { Routes } from '~/enums/Routes'
const logos = await useAssetManager().getLogos()

const { t } = useLang()
const props = defineProps<{
  slug: string | null
}>()

const howToTitle = computed(() => t('common.how_to'))
</script>

<style lang="postcss" scoped>
.header-news-component {
  @apply flex gap-2 items-center text-sm text-text1 dark:text-dmText1 alt:text-white dark:alt:text-black;
}

.dark {
  .header-news-component {
    img {
      @apply invert;
    }
  }
}

.ae .header-news-component {
  @apply font-extrabold !text-text1;

  a {
    @apply hover:!text-text1;
  }
}
</style>
